/**
 * Created by Fernando Torres on 01/02/2018.
 */
import AssignmentsListView from '@/views/app/assignments/assignments-list-view'
import AssignmentsCreateView from '@/views/app/assignments/assignments-create-view'

export default [
  {
    path: 'assignments',
    name: 'assignments',
    component: AssignmentsListView,
    children: [
      {
        path: 'create',
        name: 'assignments-create',
        component: AssignmentsCreateView
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/assignments/index.js